import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { RouteInfo } from './../routeInfo';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { YearService } from '../year/year.service';
import { Year } from '../year/year.model';
import { UserService } from '../user/user.service';

/**
 * This component generates a page header for C360 or S360.
 * Unlike the student header, this does NOT include a student portrait.
 * You may also specify what strings show up on the left-hand side of the header.
 *
 * @input leftStrings: these strings show up on the left side of the header.
 * @input leftStringSize: the font size of the left strings.
 * @input leftStringColor: the color of the left strings.
 * @Input pageTitle: the title the shows on the right
 * @input classroomPage: this indicates whether this page is part of C360. It is true by default.
 *
 * This component also supports content projection, should you prefer to use that.
 * The projected content is placed on the left side of the header.
 */
@AutoUnsubscribe()
@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css']
})
export class PageHeaderComponent implements OnInit, OnDestroy {

  // Properties
  @Input() leftStrings: string[] = [];
  @Input() leftStringSize = '18px';
  @Input() leftStringColor = 'inherit';
  @Input() classroomPage = true;
  @Input() pageTitle: string;
  @Input() forceYearDisplay: boolean;
  defaultYear: Year;
  courseRequestYear: Year;
  userType;
  screenWidth  = 0;

  // Class Funtions
  constructor(
    private yearService: YearService,
    private userService: UserService,
    private router: Router
  ) {

  }

  // Event Functions
  ngOnInit() {
    this.userType = this.userService.currentUser.UserType;
    this.defaultYear = this.yearService.defaultYear;
    this.yearService.observableDefaultYearStream$.subscribe(() => {
      this.defaultYear = this.yearService.defaultYear;
    });
    this.screenWidth = screen != null ? screen.width : 0;
  }

  ngOnDestroy() {

  }

  // Methods
  getPageTitle() {
    // POST: returns the title of this page
        return (this.pageTitle == undefined) ? RouteInfo.getPageTitle(this.router.url) : this.pageTitle;
  }
}
